<template>
  <div class="dashboard">
    <router-view></router-view>
    <!-- <Index/> -->
  </div>
</template>

<script>
 /* eslint-disable */
 import Index from '@/components/users/Index.vue';

export default {
  name: "users",
  components:{
    Index
  }
};
</script>
